var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "policy-page" }, [
    _c("div", { staticClass: "page-header" }, [
      _vm.isViewMode
        ? _c("div", { staticClass: "header-back", on: { click: _vm.goBack } }, [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d: "M15 18L9 12L15 6",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("h1", { staticClass: "page-title" }, [_vm._v("📋 条款和政策")])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    !_vm.isViewMode
      ? _c("div", { staticClass: "action-bar" }, [
          _c(
            "div",
            { staticClass: "action-btn cancel-btn", on: { click: _vm.close } },
            [_c("span", [_vm._v("取消")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action-btn accept-btn", on: { click: _vm.go_sms } },
            [_c("span", [_vm._v("接受并继续")])]
          )
        ])
      : _c("div", { staticClass: "action-bar" }, [
          _c(
            "div",
            {
              staticClass: "action-btn accept-btn",
              staticStyle: { flex: "1" },
              on: { click: _vm.goBack }
            },
            [_c("span", [_vm._v("返回")])]
          )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-container" }, [
      _c("article", { staticClass: "policy-article" }, [
        _c("section", [
          _c("h2", { staticClass: "article-title" }, [
            _vm._v("移动应用 - 使用条款")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "update-date" }, [
            _vm._v("最新修订日期：2018 年11月15日")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              '\n          下载，安装和使用【我的安视优®PLUS】移动应用程序（"'
            ),
            _c("b", [_vm._v("【我的安视优®PLUS】")]),
            _vm._v('"），构成您接受和承认以下使用条款（"'),
            _c("b", [_vm._v("条款")]),
            _vm._v('"），此处条款可由强生视力健商贸（上海）有限公司（"'),
            _c("b", [_vm._v("强生")]),
            _vm._v(
              '"）随时修订，且是眼科护理专业人士和强生公司之间关于【我的安视优®PLUS】的使用的约束性协议。\n        '
            )
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("1. 强生政策")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n          条款的补充和整合："),
            _c("b", [_vm._v('"强生政策"')]),
            _vm._v("，包括使用 [www.acuvue.com.cn]（"),
            _c("b", [_vm._v('"安视优网站"')]),
            _vm._v(
              "）的条款（包括但不限于强生隐私政策）。了解隐私政策可登陆：\n          "
            ),
            _c("a", { attrs: { href: "#/policy_new" } }, [
              _vm._v("https://plus.51i.cc/policy_new")
            ])
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("2. 用户许可")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              '\n          根据条款，强生授予眼科护理专业人士非排他的、不可转让的、有限的和可撤销的使用【我的安视优®PLUS】的许可，但须在由眼科护理专业人士拥有或控制符合此处条款（"'
            ),
            _c("b", [_vm._v("用户许可")]),
            _vm._v('"）的设备上（'),
            _c("b", [_vm._v('每个"设备"')]),
            _vm._v(
              '）为商业用途使用。禁止以其他方式使用【我的安视优®PLUS】，包括但不限于，转售、转让、修改或分销与【我的安视优®PLUS】关联的应用程序或文本、图片、音乐、条形码、视频、数据、超链接、显示器和其它内容（"'
            ),
            _c("b", [_vm._v("内容")]),
            _vm._v(
              '"）。本协议及用户许可适用于【我的安视优®PLUS】的任何更新或补充或更换，除非这些更新、补充或替代有单独适用的条款。\n        '
            )
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("3. 保密")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              '\n          3.1 为达到【我的安视优®PLUS】的用途，强生可能以书面、口头和/或其他方式向眼科护理专业人士披露某些信息。强生向眼科护理专业人士披露的此类信息不限于：新产品、商业计划、数据、专有技术、配方工艺、设计、草图、照片、计划、图纸、材料规格、产品规格、样品、财务信息、报告、研究、发现、发明、创意、客户名单、客户的个人信息、价格信息、价格协议、设定和其他任何信息。所有此类被披露的信息都是机密的（"'
            ),
            _c("b", [_vm._v("保密信息")]),
            _vm._v('"）。\n        ')
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "3.2 眼科护理专业人士同意对收到的强生保密信息保密，不向任何第三方披露或非为【我的安视优®PLUS】需要的其他目的使用保密信息。"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "3.3 眼科护理专业人士根据此处条款获得的所有包含保密信息，和其他有形的保密材料的书面和电子文件都是强生公司的财产。"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              '3.4 眼科护理专业人士承认并同意是按"现状"为基础接受的信息，即对其准确性、完整性或其他方面无任何明示、暗示或其他方式担保。'
            )
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("4. 用户信息")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              '\n          访问"我的安视优®PLUS"，您需要提供一定的信息（包括以下定义的个人信息）以创建账户。您知晓并同意强生各公司及分支机构（"'
            ),
            _c("b", [_vm._v("强生公司")]),
            _vm._v(
              '"）就经营和推广强生产品及服务、强生公司内部管理、强生产品及服务的数据分析和统计等目的（"'
            ),
            _c("b", [_vm._v("目的")]),
            _vm._v('"），收集、分享、处理、储存和使用您的个人信息。\n        ')
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "您知晓并同意，为实现上述目的，强生可能与代表强生公司履行职能的代理商、经销商和/或服务提供商分享您的个人信息。"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "您注册为会员即表示同意并授权强生公司及受托公司通过信件、电子邮件和/或通过包括社交网络平台在内的其他数据形式的方式向您主动发送强生产品及服务相关推广、营销、知识教育信息或向您发起呼叫。"
            )
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("5. 可接受的使用")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "【我的安视优®PLUS】和任何通过【我的安视优®PLUS】连接传输的内容、信息及保密信息仅限于设定功能的使用。"
            )
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("21. 适用法律和管辖权")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "此处条款适用中国的法律，不考虑法律冲突规则。因使用【我的安视优®PLUS】或此处条款产生或涉及的任何法律行动，眼科护理专业人士不可撤销地同意中国法院的专属管辖权。"
            )
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("24. 联系强生公司")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "如有任何关于【我的安视优®PLUS】的疑问、投诉可直接联系服务您的强生公司销售经理。"
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("电话：400-882-3636")]),
          _vm._v(" "),
          _c("p", [_vm._v("邮件：support@acuvue.com.cn")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0573f2cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0573f2cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/policy.vue
// module id = null
// module chunks = 